import styled from '@emotion/styled';

import { FontFamily } from '@/enums/index';
import { IThemeProps } from '@/styles/themes/types';

export const SectionTitle = styled.p<IThemeProps>`
  font-family: ${FontFamily.SpaceGrotesk};
  font-weight: bold;
  font-size: 16px;
  line-height: 18px;
  text-transform: uppercase;
  margin: 0;
  padding-bottom: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.legacy.colors.gray80};
`;
